export default __webpack_public_path__ + "static/media/sounds/spelling_practice_instruction_start_alyx.mp3";